/* App.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	check_outros,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	group_outros,
	init,
	insert,
	listen,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "svelte/internal";

import Spinner from "./Spinner.svelte";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (131:4) {#each readings as reading}
function create_each_block(ctx) {
	let iframe;
	let iframe_title_value;
	let iframe_src_value;
	let mounted;
	let dispose;

	return {
		c() {
			iframe = element("iframe");
			attr(iframe, "class", "audio-player svelte-g4ip1j");
			attr(iframe, "title", iframe_title_value = "Audio for " + /*reading*/ ctx[7]);
			if (iframe.src !== (iframe_src_value = "https://www.esv.org/audio-player/" + /*reading*/ ctx[7] + "/")) attr(iframe, "src", iframe_src_value);
		},
		m(target, anchor) {
			insert(target, iframe, anchor);

			if (!mounted) {
				dispose = listen(iframe, "load", /*handleAudioLoad*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, dirty) {
			if (dirty & /*readings*/ 4 && iframe_title_value !== (iframe_title_value = "Audio for " + /*reading*/ ctx[7])) {
				attr(iframe, "title", iframe_title_value);
			}

			if (dirty & /*readings*/ 4 && iframe.src !== (iframe_src_value = "https://www.esv.org/audio-player/" + /*reading*/ ctx[7] + "/")) {
				attr(iframe, "src", iframe_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(iframe);
			mounted = false;
			dispose();
		}
	};
}

// (140:2) {#if !loaded}
function create_if_block(ctx) {
	let div;
	let spinner;
	let current;
	spinner = new Spinner({});

	return {
		c() {
			div = element("div");
			create_component(spinner.$$.fragment);
			attr(div, "class", "loading svelte-g4ip1j");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(spinner, div, null);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(spinner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(spinner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(spinner);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let header;
	let h1;
	let t0;
	let t1;
	let h2;
	let t3;
	let main;
	let t4;
	let t5;
	let footer;
	let t6;
	let a0;
	let t8;
	let t9;
	let t10;
	let a1;
	let t12;
	let current;
	let each_value = /*readings*/ ctx[2];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	let if_block = !/*loaded*/ ctx[3] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			header = element("header");
			h1 = element("h1");
			t0 = text(/*title*/ ctx[0]);
			t1 = space();
			h2 = element("h2");
			h2.textContent = "MacArthur Daily Bible";
			t3 = space();
			main = element("main");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			t4 = space();
			if (if_block) if_block.c();
			t5 = space();
			footer = element("footer");
			t6 = text("Daily Bible readings from the one-year reading plan in the\n    ");
			a0 = element("a");
			a0.textContent = "MacArthur Daily Bible";
			t8 = text(", copyright\n    ");
			t9 = text(/*copyright*/ ctx[1]);
			t10 = text(". Built by\n    ");
			a1 = element("a");
			a1.textContent = "Michael Spencer";
			t12 = text(".");
			attr(h1, "class", "svelte-g4ip1j");
			attr(h2, "class", "svelte-g4ip1j");
			attr(header, "class", "svelte-g4ip1j");
			attr(main, "class", "svelte-g4ip1j");
			toggle_class(main, "hide", !/*loaded*/ ctx[3]);
			attr(a0, "href", "https://www.gty.org/library/devotionals/daily-bible");
			attr(a0, "target", "_blank");
			attr(a0, "class", "svelte-g4ip1j");
			attr(a1, "href", "https://github.com/ibelieve/gty-daily-audio-bible");
			attr(a1, "target", "_blank");
			attr(a1, "class", "svelte-g4ip1j");
			attr(footer, "class", "svelte-g4ip1j");
			toggle_class(footer, "hide", !/*loaded*/ ctx[3]);
			attr(div, "id", "root");
			attr(div, "class", "svelte-g4ip1j");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, header);
			append(header, h1);
			append(h1, t0);
			append(header, t1);
			append(header, h2);
			append(div, t3);
			append(div, main);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(main, null);
			}

			append(div, t4);
			if (if_block) if_block.m(div, null);
			append(div, t5);
			append(div, footer);
			append(footer, t6);
			append(footer, a0);
			append(footer, t8);
			append(footer, t9);
			append(footer, t10);
			append(footer, a1);
			append(footer, t12);
			current = true;
		},
		p(ctx, [dirty]) {
			if (!current || dirty & /*title*/ 1) set_data(t0, /*title*/ ctx[0]);

			if (dirty & /*readings, handleAudioLoad*/ 20) {
				each_value = /*readings*/ ctx[2];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(main, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*loaded*/ 8) {
				toggle_class(main, "hide", !/*loaded*/ ctx[3]);
			}

			if (!/*loaded*/ ctx[3]) {
				if (if_block) {
					if (dirty & /*loaded*/ 8) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(div, t5);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}

			if (!current || dirty & /*copyright*/ 2) set_data(t9, /*copyright*/ ctx[1]);

			if (dirty & /*loaded*/ 8) {
				toggle_class(footer, "hide", !/*loaded*/ ctx[3]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			if (if_block) if_block.d();
		}
	};
}

const DAILY_BIBLE_FEED = "https://feeds.gty.org/gtydailybible&x=1";

function instance($$self, $$props, $$invalidate) {
	const domParser = new DOMParser();
	let title = new Intl.DateTimeFormat("en", { month: "long", day: "numeric" }).format(new Date());
	let copyright = "2017 by Grace to You";
	let readings = [];
	let loading = 0;
	let loaded = false;

	(async () => {
		const response = await fetch(DAILY_BIBLE_FEED);
		const feedText = await response.text();
		const feed = domParser.parseFromString(feedText, "text/xml");
		const feedItem = feed.querySelector("rss > channel > item:first-of-type");
		$$invalidate(1, copyright = feed.querySelector("rss > channel > copyright").textContent);
		$$invalidate(0, title = feedItem.querySelector("title").textContent);
		const contentText = feedItem.querySelector("description").textContent;
		const content = domParser.parseFromString(contentText, "text/html");
		$$invalidate(2, readings = Array.from(content.querySelectorAll("ul:first-of-type li")).map(elem => elem.innerText));
		loading = readings.length;
	})();

	function handleAudioLoad() {
		loading--;

		if (loading == 0) {
			$$invalidate(3, loaded = true);
		}
	}

	return [title, copyright, readings, loaded, handleAudioLoad];
}

class App extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default App;